import { render, staticRenderFns } from "./apiAuthorization2.vue?vue&type=template&id=439cf408&scoped=true&"
import script from "./apiAuthorization2.vue?vue&type=script&lang=js&"
export * from "./apiAuthorization2.vue?vue&type=script&lang=js&"
import style0 from "./apiAuthorization2.vue?vue&type=style&index=0&id=439cf408&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439cf408",
  null
  
)

export default component.exports